<div class="container-fluid g-0 m-0">
  <div class="row g-0 m-0 d-flex pt-5 align-items-center">
    <div class="col-md-1 d-flex pe-4 justify-content-end">
      <div class="button-back pb-3" (click)="onBack()">
        <svg-icon alt="Back" src="assets/core/back-button.svg"></svg-icon>
      </div>
    </div>
    <div class="col-md-11">
      <h2 class="col pb-2 m-0 title">
        {{ "ONDEMANDREAD" | translate }}
      </h2>
      <p class="col subtitle">{{ "ONDEMANDCUSTOMREG_SUBTITLE" | translate }}</p>
    </div>
  </div>
  <form #crudform="ngForm" (ngSubmit)="onSubmit()" class="d-flex flex-column">
    <div class="form-item">
      <label class="form-label" for="meterNo">{{
        "DEVICESETUP_METERNO" | translate
      }}</label>
      <div class="form-input">
        <input
          id="meterNo"
          [(ngModel)]="requestData.meterNo"
          (ngModelChange)="onMeterNoChange(requestData.meterNo!, meterNoModel)"
          #meterNoModel="ngModel"
          name="meterNo"
          type="text"
          pattern="^[0-9]+$"
          required
        />
        @if (crudform.submitted && meterNoModel.invalid) {
          {{ "DEVICESETUP_METERNO" | translate
          }}{{ "DEVICESETUP_ISREQUIRED" | translate }}
        }
        @if (!requestData.meterNo || requestData.meterNo.trim() === "") {
          <div class="validation-instruction">
            {{ "DEVICESETUP_METERNODESC" | translate }}
          </div>
        } @else if (meterNoModel.invalid && meterNoModel.errors?.["pattern"]) {
          <div class="validation-error">
            {{ "METERNUMBER_ERROR" | translate }}
          </div>
        }
      </div>
    </div>
    <div class="form-item overflow-vertical">
      <div class="subpage-container mb-5">
        <div class="container g-0 m-0">
          <table *ngIf="associations.length > 0">
            <thead>
              <tr>
                <th></th>
                <th>{{ "NAME" | translate }}</th>
                <th>{{ "OBIS_CODE" | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let row of associations; let i = index"
                (click)="toggleRow(i)"
                style="cursor: pointer"
              >
                <td class="ps-1">
                  <input
                    class="form-check-input custom-checkbox"
                    type="checkbox"
                    [(ngModel)]="row.inUse"
                    name="checkbox-{{ i }}"
                    (click)="$event.stopPropagation()"
                  />
                </td>
                <td>
                  <span>{{ row.name }}</span>
                </td>
                <td>
                  <span>{{ row.obis }}</span>
                </td>
              </tr>
            </tbody>
          </table>
          @if (
            this.requestData.meterNo!.trim() &&
            associations.length === 0 &&
            registerListFetchInProgress === false
          ) {
            <div class="validation-error">
              {{ "NO_AVAILABLE_REGISTERS" | translate }}
            </div>
          }
        </div>
      </div>
    </div>

    <div class="form-item-button">
      <button
        class="button-submit"
        [disabled]="crudform.invalid || !isAnyCheckboxChecked"
        type="submit"
      >
        {{ "CONTINUE" | translate }}
      </button>
    </div>
  </form>
</div>
